var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"calc(100% - 60px)","overflow":"hidden"}},[(_vm.listRoleFlag)?_c('list-role',{attrs:{"listRoleFlag":_vm.listRoleFlag},on:{"changeView":_vm.changeView}}):_c('edit-role',{attrs:{"listRoleFlag":_vm.listRoleFlag},on:{"changeView":_vm.changeView}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }